<template>
    <all-topics type="list" />
</template>

<script>
import AllTopics from './All'

export default {
    components: { AllTopics },
    name: 'List',
}
</script>